import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react';

import { useNavigate } from 'react-router-dom';

import { API_BASE_URL } from '../config';

import {

  Box,

  Typography,

  Card,

  CardContent,

  Table,

  TableBody,

  TableCell,

  TableContainer,

  TableHead,

  TableRow,

  TableSortLabel,

  IconButton,

  Button,

  Dialog,

  DialogTitle,

  DialogContent,

  DialogActions,

  TextField,

  Grid,

  Chip,

  CircularProgress,

  Alert,

  Tooltip,

  Checkbox,

  TablePagination,

  FormControl,

  InputLabel,

  Select,

  MenuItem,

  Autocomplete,

  Divider,

  Snackbar,

  InputAdornment

} from '@mui/material';

import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import ColumnVisibilityMenu, { ColumnOption } from '../components/ColumnVisibilityMenu';

import EditIcon from '@mui/icons-material/Edit';

import DeleteIcon from '@mui/icons-material/Delete';

import SearchIcon from '@mui/icons-material/Search';

import ClearIcon from '@mui/icons-material/Clear';

import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';

import MarkunreadMailboxIcon from '@mui/icons-material/MarkunreadMailbox';

import LinkIcon from '@mui/icons-material/Link';

import AttachMoneyIcon from '@mui/icons-material/AttachMoney';

import axios from 'axios';

import { useAuth } from '../contexts/AuthContext';
import {
  getCachedPublishers,
  getCachedCategories,
  getCachedUsers,
  invalidatePublishersCache
} from '../cache/appDataCache';
import {
  toAutocompleteOption,
  findLanguageOption,
  findCountryOption
} from '../utils/optionResolvers';

// Fallback categories if API fails
const FALLBACK_CATEGORIES = [
  { value: "AI_FUTURE_TECH", label: "AI & Future Tech" },
  { value: "AUTOMOBILE", label: "Automobile" },
  { value: "BUSINESS_ENTREPRENEURSHIP", label: "Business & Entrepreneurship" },
  { value: "CASINO", label: "Casino" },
  { value: "ECOMMERCE_STARTUPS", label: "E-commerce & Startups" },
  { value: "EDUCATION_CAREER", label: "Education & Career" },
  { value: "ENTERTAINMENT_MEDIA", label: "Entertainment & Media" },
  { value: "ENVIRONMENT", label: "Environment" },
  { value: "ESPORTS", label: "Esports" },
  { value: "FAMILY", label: "Family" },
  { value: "FASHION_BEAUTY", label: "Fashion & Beauty" },
  { value: "FINANCE_INVESTMENT", label: "Finance & Investment" },
  { value: "FOOD_NUTRITION", label: "Food & Nutrition" },
  { value: "GAMING", label: "Gaming" },
  { value: "GENERAL", label: "General" },
  { value: "HEALTH_FITNESS", label: "Health & Fitness" },
  { value: "HOME_IMPROVEMENT", label: "Home Improvement" },
  { value: "LAW", label: "Law" },
  { value: "LIFESTYLE_WELLNESS", label: "Lifestyle & Wellness" },
  { value: "MAGAZINE", label: "Magazine" },
  { value: "MARKETING_SEO", label: "Marketing & SEO" },
  { value: "NEWS", label: "News" },
  { value: "PARENTING_RELATIONSHIPS", label: "Parenting & Relationships" },
  { value: "REAL_ESTATE", label: "Real Estate" },
  { value: "SPORTS_FITNESS", label: "Sports & Fitness" },
  { value: "SUSTAINABILITY_GREEN_LIVING", label: "Sustainability & Green Living" },
  { value: "TECHNOLOGY_GADGETS", label: "Technology & Gadgets" },
  { value: "TRAVEL_TOURISM", label: "Travel & Tourism" },
  { value: "OTHERS", label: "Others" }
];



// Country options with ISO codes (matching main tool format)

const COUNTRIES = [

  { value: "AF", label: "Afghanistan" },

  { value: "AL", label: "Albania" },

  { value: "DZ", label: "Algeria" },

  { value: "AD", label: "Andorra" },

  { value: "AO", label: "Angola" },

  { value: "AG", label: "Antigua and Barbuda" },

  { value: "AR", label: "Argentina" },

  { value: "AM", label: "Armenia" },

  { value: "AU", label: "Australia" },

  { value: "AT", label: "Austria" },

  { value: "AZ", label: "Azerbaijan" },

  { value: "BS", label: "Bahamas" },

  { value: "BH", label: "Bahrain" },

  { value: "BD", label: "Bangladesh" },

  { value: "BB", label: "Barbados" },

  { value: "BY", label: "Belarus" },

  { value: "BE", label: "Belgium" },

  { value: "BZ", label: "Belize" },

  { value: "BJ", label: "Benin" },

  { value: "BT", label: "Bhutan" },

  { value: "BO", label: "Bolivia" },

  { value: "BA", label: "Bosnia and Herzegovina" },

  { value: "BW", label: "Botswana" },

  { value: "BR", label: "Brazil" },

  { value: "BN", label: "Brunei" },

  { value: "BG", label: "Bulgaria" },

  { value: "BF", label: "Burkina Faso" },

  { value: "BI", label: "Burundi" },

  { value: "CV", label: "Cabo Verde" },

  { value: "KH", label: "Cambodia" },

  { value: "CM", label: "Cameroon" },

  { value: "CA", label: "Canada" },

  { value: "CF", label: "Central African Republic" },

  { value: "TD", label: "Chad" },

  { value: "CL", label: "Chile" },

  { value: "CN", label: "China" },

  { value: "CO", label: "Colombia" },

  { value: "KM", label: "Comoros" },

  { value: "CG", label: "Congo" },

  { value: "CR", label: "Costa Rica" },

  { value: "HR", label: "Croatia" },

  { value: "CU", label: "Cuba" },

  { value: "CY", label: "Cyprus" },

  { value: "CZ", label: "Czech Republic" },

  { value: "DK", label: "Denmark" },

  { value: "DJ", label: "Djibouti" },

  { value: "DM", label: "Dominica" },

  { value: "DO", label: "Dominican Republic" },

  { value: "EC", label: "Ecuador" },

  { value: "EG", label: "Egypt" },

  { value: "SV", label: "El Salvador" },

  { value: "GQ", label: "Equatorial Guinea" },

  { value: "ER", label: "Eritrea" },

  { value: "EE", label: "Estonia" },

  { value: "SZ", label: "Eswatini" },

  { value: "ET", label: "Ethiopia" },

  { value: "FJ", label: "Fiji" },

  { value: "FI", label: "Finland" },

  { value: "FR", label: "France" },

  { value: "GA", label: "Gabon" },

  { value: "GM", label: "Gambia" },

  { value: "GE", label: "Georgia" },

  { value: "DE", label: "Germany" },

  { value: "GH", label: "Ghana" },

  { value: "GR", label: "Greece" },

  { value: "GD", label: "Grenada" },

  { value: "GT", label: "Guatemala" },

  { value: "GN", label: "Guinea" },

  { value: "GW", label: "Guinea-Bissau" },

  { value: "GY", label: "Guyana" },

  { value: "HT", label: "Haiti" },

  { value: "HN", label: "Honduras" },

  { value: "HU", label: "Hungary" },

  { value: "IS", label: "Iceland" },

  { value: "IN", label: "India" },

  { value: "ID", label: "Indonesia" },

  { value: "IR", label: "Iran" },

  { value: "IQ", label: "Iraq" },

  { value: "IE", label: "Ireland" },

  { value: "IL", label: "Israel" },

  { value: "IT", label: "Italy" },

  { value: "JM", label: "Jamaica" },

  { value: "JP", label: "Japan" },

  { value: "JO", label: "Jordan" },

  { value: "KZ", label: "Kazakhstan" },

  { value: "KE", label: "Kenya" },

  { value: "KI", label: "Kiribati" },

  { value: "KW", label: "Kuwait" },

  { value: "KG", label: "Kyrgyzstan" },

  { value: "LA", label: "Laos" },

  { value: "LV", label: "Latvia" },

  { value: "LB", label: "Lebanon" },

  { value: "LS", label: "Lesotho" },

  { value: "LR", label: "Liberia" },

  { value: "LY", label: "Libya" },

  { value: "LI", label: "Liechtenstein" },

  { value: "LT", label: "Lithuania" },

  { value: "LU", label: "Luxembourg" },

  { value: "MG", label: "Madagascar" },

  { value: "MW", label: "Malawi" },

  { value: "MY", label: "Malaysia" },

  { value: "MV", label: "Maldives" },

  { value: "ML", label: "Mali" },

  { value: "MT", label: "Malta" },

  { value: "MH", label: "Marshall Islands" },

  { value: "MR", label: "Mauritania" },

  { value: "MU", label: "Mauritius" },

  { value: "MX", label: "Mexico" },

  { value: "FM", label: "Micronesia" },

  { value: "MD", label: "Moldova" },

  { value: "MC", label: "Monaco" },

  { value: "MN", label: "Mongolia" },

  { value: "ME", label: "Montenegro" },

  { value: "MA", label: "Morocco" },

  { value: "MZ", label: "Mozambique" },

  { value: "MM", label: "Myanmar" },

  { value: "NA", label: "Namibia" },

  { value: "NR", label: "Nauru" },

  { value: "NP", label: "Nepal" },

  { value: "NL", label: "Netherlands" },

  { value: "NZ", label: "New Zealand" },

  { value: "NI", label: "Nicaragua" },

  { value: "NE", label: "Niger" },

  { value: "NG", label: "Nigeria" },

  { value: "KP", label: "North Korea" },

  { value: "MK", label: "North Macedonia" },

  { value: "NO", label: "Norway" },

  { value: "OM", label: "Oman" },

  { value: "PK", label: "Pakistan" },

  { value: "PW", label: "Palau" },

  { value: "PS", label: "Palestine" },

  { value: "PA", label: "Panama" },

  { value: "PG", label: "Papua New Guinea" },

  { value: "PY", label: "Paraguay" },

  { value: "PE", label: "Peru" },

  { value: "PH", label: "Philippines" },

  { value: "PL", label: "Poland" },

  { value: "PT", label: "Portugal" },

  { value: "QA", label: "Qatar" },

  { value: "RO", label: "Romania" },

  { value: "RU", label: "Russia" },

  { value: "RW", label: "Rwanda" },

  { value: "KN", label: "Saint Kitts and Nevis" },

  { value: "LC", label: "Saint Lucia" },

  { value: "VC", label: "Saint Vincent and the Grenadines" },

  { value: "WS", label: "Samoa" },

  { value: "SM", label: "San Marino" },

  { value: "ST", label: "Sao Tome and Principe" },

  { value: "SA", label: "Saudi Arabia" },

  { value: "SN", label: "Senegal" },

  { value: "RS", label: "Serbia" },

  { value: "SC", label: "Seychelles" },

  { value: "SL", label: "Sierra Leone" },

  { value: "SG", label: "Singapore" },

  { value: "SK", label: "Slovakia" },

  { value: "SI", label: "Slovenia" },

  { value: "SB", label: "Solomon Islands" },

  { value: "SO", label: "Somalia" },

  { value: "ZA", label: "South Africa" },

  { value: "KR", label: "South Korea" },

  { value: "SS", label: "South Sudan" },

  { value: "ES", label: "Spain" },

  { value: "LK", label: "Sri Lanka" },

  { value: "SD", label: "Sudan" },

  { value: "SR", label: "Suriname" },

  { value: "SE", label: "Sweden" },

  { value: "CH", label: "Switzerland" },

  { value: "SY", label: "Syria" },

  { value: "TW", label: "Taiwan" },

  { value: "TJ", label: "Tajikistan" },

  { value: "TZ", label: "Tanzania" },

  { value: "TH", label: "Thailand" },

  { value: "TL", label: "Timor-Leste" },

  { value: "TG", label: "Togo" },

  { value: "TO", label: "Tonga" },

  { value: "TT", label: "Trinidad and Tobago" },

  { value: "TN", label: "Tunisia" },

  { value: "TR", label: "Turkey" },

  { value: "TM", label: "Turkmenistan" },

  { value: "TV", label: "Tuvalu" },

  { value: "UG", label: "Uganda" },

  { value: "UA", label: "Ukraine" },

  { value: "AE", label: "United Arab Emirates" },

  { value: "UK", label: "United Kingdom" },

  { value: "US", label: "United States" },

  { value: "UY", label: "Uruguay" },

  { value: "UZ", label: "Uzbekistan" },

  { value: "VU", label: "Vanuatu" },

  { value: "VA", label: "Vatican City" },

  { value: "VE", label: "Venezuela" },

  { value: "VN", label: "Vietnam" },

  { value: "YE", label: "Yemen" },

  { value: "ZM", label: "Zambia" },

  { value: "ZW", label: "Zimbabwe" }

];



// Language options with lowercase short codes

const LANGUAGES = [

  { value: "en", label: "English" },

  { value: "es", label: "Spanish" },

  { value: "fr", label: "French" },

  { value: "de", label: "German" },

  { value: "it", label: "Italian" },

  { value: "pt", label: "Portuguese" },

  { value: "ru", label: "Russian" },

  { value: "zh", label: "Chinese" },

  { value: "ja", label: "Japanese" },

  { value: "ko", label: "Korean" },

  { value: "ar", label: "Arabic" },

  { value: "hi", label: "Hindi" },

  { value: "bn", label: "Bengali" },

  { value: "pa", label: "Punjabi" },

  { value: "ur", label: "Urdu" },

  { value: "vi", label: "Vietnamese" },

  { value: "th", label: "Thai" },

  { value: "tr", label: "Turkish" },

  { value: "pl", label: "Polish" },

  { value: "uk", label: "Ukrainian" },

  { value: "ro", label: "Romanian" },

  { value: "nl", label: "Dutch" },

  { value: "el", label: "Greek" },

  { value: "hu", label: "Hungarian" },

  { value: "cs", label: "Czech" },

  { value: "sv", label: "Swedish" },

  { value: "da", label: "Danish" },

  { value: "fi", label: "Finnish" },

  { value: "no", label: "Norwegian" },

  { value: "sk", label: "Slovak" },

  { value: "hr", label: "Croatian" },

  { value: "bg", label: "Bulgarian" },

  { value: "sr", label: "Serbian" },

  { value: "sl", label: "Slovenian" },

  { value: "lt", label: "Lithuanian" },

  { value: "lv", label: "Latvian" },

  { value: "et", label: "Estonian" },

  { value: "he", label: "Hebrew" },

  { value: "id", label: "Indonesian" },

  { value: "ms", label: "Malay" },

  { value: "tl", label: "Filipino" },

  { value: "sw", label: "Swahili" },

  { value: "fa", label: "Persian" },

  { value: "ta", label: "Tamil" },

  { value: "te", label: "Telugu" },

  { value: "mr", label: "Marathi" },

  { value: "gu", label: "Gujarati" },

  { value: "kn", label: "Kannada" },

  { value: "ml", label: "Malayalam" },

  { value: "ne", label: "Nepali" },

  { value: "si", label: "Sinhala" },

  { value: "my", label: "Burmese" },

  { value: "km", label: "Khmer" },

  { value: "lo", label: "Lao" },

  { value: "am", label: "Amharic" },

  { value: "other", label: "Other" }

];



interface Publisher {

  id: string;

  email: string | null;

  publisherName: string;

}



interface DataFinalRecord {

  id: string;

  websiteUrl: string;

  publisherName?: string;

  publisherEmail?: string;

  publisherId?: string;

  publisherMatched?: boolean;

  contactName?: string;

  contactEmail?: string;

  da?: number;

  dr?: number;

  traffic?: number;

  ss?: number;

  keywords?: number;

  domainAge?: string;

  imageLink?: string;

  category?: string;

  country?: string;

  language?: string;

  tat?: string;

  gbBasePrice?: number;

  liBasePrice?: number;

  status: string;

  negotiationStatus: string;

  createdAt: string;

  reachedBy?: string;

  reachedByName?: string;

  reachedAt?: string;

  lastModifiedBy?: string;

  lastModifiedByName?: string;

  mainProjectId?: string;

  pushedAt?: string;

  pushedBy?: string;

  reachedByUser?: {

    firstName: string;

    lastName: string;

    role: string;

  };

  uploadTask?: {

    id: string;

    fileName: string;

    assignedTo: string;

    createdBy: string;

  };

}



const DATA_FINAL_COLUMN_KEY = 'data-final-visible-columns';

function dataFinalColumns(role?: string): ColumnOption[] {
  const cols: ColumnOption[] = [
    { key: 'url', label: 'Site URL', required: true },
    { key: 'imageLink', label: 'Image Link' },
    { key: 'publisher', label: 'Publisher / Contact' }
  ];
  if (role === 'SUPER_ADMIN') {
    cols.push({ key: 'email', label: 'Email' });
  }
  cols.push(
    { key: 'da', label: 'DA' },
    { key: 'dr', label: 'DR' },
    { key: 'traffic', label: 'Traffic' },
    { key: 'ss', label: 'SS' },
    { key: 'keywords', label: 'Keywords' },
    { key: 'domainAge', label: 'Domain Age' },
    { key: 'category', label: 'Category' },
    { key: 'country', label: 'Country' },
    { key: 'language', label: 'Language' },
    { key: 'tat', label: 'TAT' },
    { key: 'gbPrice', label: 'GB Base Price' },
    { key: 'liPrice', label: 'LI Base Price' },
    { key: 'status', label: 'Status' },
    { key: 'negotiation', label: 'Negotiation Status' }
  );
  if (role !== 'CONTRIBUTOR') {
    cols.push({ key: 'markedBy', label: 'Marked As Email Sent By' });
  }
  cols.push({ key: 'createdAt', label: 'Created Date' });
  return cols;
}

const DataFinal: React.FC = () => {

  const { user } = useAuth();

  const columnOptions = useMemo(() => dataFinalColumns(user?.role), [user?.role]);

  const [visibleColumns, setVisibleColumns] = useState<Set<string>>(() => {
    try {
      const raw = localStorage.getItem(DATA_FINAL_COLUMN_KEY);
      if (raw) {
        const saved = JSON.parse(raw) as string[];
        if (Array.isArray(saved) && saved.length > 0) {
          return new Set([...saved, 'url']);
        }
      }
    } catch {
      // ignore bad storage
    }
    return new Set(dataFinalColumns('SUPER_ADMIN').map((c) => c.key));
  });

  const showCol = (key: string) => key === 'url' || visibleColumns.has(key);

  const toggleColumn = (key: string) => {
    setVisibleColumns((prev) => {
      const next = new Set(prev);
      if (next.has(key)) next.delete(key);
      else next.add(key);
      next.add('url');
      localStorage.setItem(DATA_FINAL_COLUMN_KEY, JSON.stringify([...next]));
      return next;
    });
  };

  const navigate = useNavigate();

  const [data, setData] = useState<DataFinalRecord[]>([]);

  const [loading, setLoading] = useState(true);

  const [error, setError] = useState('');

  const [selectedRecord, setSelectedRecord] = useState<DataFinalRecord | null>(null);

  const [showEditDialog, setShowEditDialog] = useState(false);

  const [showViewDialog, setShowViewDialog] = useState(false);

  const [saving, setSaving] = useState(false);

  const [searchText, setSearchText] = useState('');

  const [debouncedSearchText, setDebouncedSearchText] = useState('');

  const [filterByUser, setFilterByUser] = useState<string>('all');

  const [filterByPublisher, setFilterByPublisher] = useState<string>('');

  const [filterByFile, setFilterByFile] = useState<string>('');

  const [filterByStatus, setFilterByStatus] = useState<string>('');

  const [allPublisherEmails, setAllPublisherEmails] = useState<string[]>([]);

  const [uploadFiles, setUploadFiles] = useState<Array<{ id: string; fileName: string }>>([]);

  const [users, setUsers] = useState<Array<{ id: string; firstName: string; lastName: string }>>([]);

  const [selectedIds, setSelectedIds] = useState<Set<string>>(new Set());

  

  // Pagination state

  const [page, setPage] = useState(0);

  const [rowsPerPage, setRowsPerPage] = useState(50);

  const [sortBy, setSortBy] = useState<'dr' | 'traffic' | null>(null);

  const [sortOrder, setSortOrder] = useState<'asc' | 'desc'>('asc');

  const [deleting, setDeleting] = useState(false);

  const [success, setSuccess] = useState('');

  const [pushing, setPushing] = useState(false);

  const [creatingPublisher, setCreatingPublisher] = useState(false);

  const [showCreatePublisherDialog, setShowCreatePublisherDialog] = useState(false);

  const [createPublisherRecord, setCreatePublisherRecord] = useState<DataFinalRecord | null>(null);

  const [exporting, setExporting] = useState(false);

  const [importing, setImporting] = useState(false);

  const fileInputRef = useRef<HTMLInputElement>(null);

  

  // Export state

  const [showExportDialog, setShowExportDialog] = useState(false);

  const [exportPublishers, setExportPublishers] = useState<Array<{

    id: string;

    email: string;

    name: string;

    isMatched: boolean;

    recordCount: number;

  }>>([]);

  const [selectedExportPublisher, setSelectedExportPublisher] = useState<string>('');

  

  // Publisher state

  const [publishers, setPublishers] = useState<Publisher[]>([]);

  const [loadingPublishers, setLoadingPublishers] = useState(false);

  const [selectedPublisher, setSelectedPublisher] = useState<Publisher | null>(null);

  // Categories state
  const [categories, setCategories] = useState<Array<{ value: string; label: string }>>(FALLBACK_CATEGORIES);



  // Toast notification state

  const [snackbar, setSnackbar] = useState<{

    open: boolean;

    message: string;

    severity: 'success' | 'error' | 'info' | 'warning';

  }>({ open: false, message: '', severity: 'success' });



  const showToast = (message: string, severity: 'success' | 'error' | 'info' | 'warning' = 'success') => {

    setSnackbar({ open: true, message, severity });

  };

  

  // Edit form state

  const [editFormData, setEditFormData] = useState({

    publisherEmail: '',

    publisherName: '',

    publisherMatched: false,

    contactName: '',

    contactEmail: '',

    da: '',

    dr: '',

    traffic: '',

    ss: '',

    keywords: '',

    domainAge: '',

    category: '',

    country: '',

    language: '',

    tat: '',

    gbBasePrice: '',

    liBasePrice: '',

    status: '',

    negotiationStatus: '',

    imageLink: ''

  });



  // Fetch publishers from main project (shared cache)

  const fetchPublishers = useCallback(async (forceRefresh = false) => {

    setLoadingPublishers(true);

    try {

      const list = await getCachedPublishers(forceRefresh);

      setPublishers(list);

    } catch (err) {

      console.error('Failed to fetch publishers:', err);

    } finally {

      setLoadingPublishers(false);

    }

  }, []);



  // Fetch publishers for export dropdown

  const fetchExportPublishers = async () => {

    try {

      const token = localStorage.getItem('token');

      const response = await axios.get(`${API_BASE_URL}/data-final/publishers/list`, {

        headers: { Authorization: `Bearer ${token}` }

      });

      if (response.data.success) {

        setExportPublishers(response.data.data || []);

      }

    } catch (err) {

      console.error('Failed to fetch export publishers:', err);

    }

  };



  // Handle publisher selection - auto-fill email and name

  const handlePublisherChange = (publisher: Publisher | null) => {

    setSelectedPublisher(publisher);

    if (publisher) {

      setEditFormData(prev => ({

        ...prev,

        publisherEmail: publisher.email || '',

        publisherName: publisher.publisherName || ''

      }));

    }

  };



  // Fetch categories from API on component mount (shared cache)
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const list = await getCachedCategories();
        if (list.length > 0) {
          setCategories(list);
        }
      } catch (error) {
        console.error('Error fetching categories from API, using fallback:', error);
        // Categories already initialized with FALLBACK_CATEGORIES
      }
    };

    fetchCategories();
  }, []);

  // Debounce search text - wait 500ms after user stops typing

  useEffect(() => {

    const timer = setTimeout(() => {

      setDebouncedSearchText(searchText);

    }, 500);



    return () => clearTimeout(timer);

  }, [searchText]);



  // Load shared dropdown data once on mount (not on every filter change)
  useEffect(() => {

    fetchPublishers();

    if (user?.role === 'SUPER_ADMIN') {

      fetchUsers();

      fetchExportPublishers();

    }

  }, [fetchPublishers, user?.role]);



  // Table data only — filters/search trigger this (avoids duplicate mount fetch)
  useEffect(() => {

    fetchData();

  }, [filterByUser, filterByPublisher, filterByFile, filterByStatus, debouncedSearchText]);



  const fetchUsers = async () => {

    try {

      const usersList = await getCachedUsers();

      // Filter out CONTRIBUTOR role users

      const filteredUsers = usersList.filter((u: any) => u.role !== 'CONTRIBUTOR');

      setUsers(filteredUsers);

    } catch (err: any) {

      console.error('Error fetching users:', err);

    }

  };



  const fetchData = async () => {

    try {

      setLoading(true);

      const token = localStorage.getItem('token');

      

      const params = new URLSearchParams();

      if (filterByUser !== 'all') {

        params.append('reachedBy', filterByUser);

      }

      if (filterByPublisher) {

        params.append('publisher', filterByPublisher);

      }

      if (filterByFile) {

        params.append('uploadTaskId', filterByFile);

      }

      if (filterByStatus) {

        params.append('status', filterByStatus);

      }

      if (debouncedSearchText) {

        params.append('search', debouncedSearchText);

      }

      

      const url = `${API_BASE_URL}/data-final${params.toString() ? '?' + params.toString() : ''}`;

      

      const response = await axios.get(url, {

        headers: {

          Authorization: `Bearer ${token}`

        }

      });



      const result = response.data.data;

      const records = result.data || [];

      setData(records);

      

      // Extract unique publisher/contact emails for filter dropdown (only when not filtering by publisher)

      if (!filterByPublisher) {

        const uniqueEmails = Array.from(

          new Set(

            records.map((r: DataFinalRecord) => r.publisherEmail || r.contactEmail).filter(Boolean)

          )

        );

        setAllPublisherEmails(uniqueEmails as string[]);

      }

      

      // Extract unique upload files for filter dropdown (only when not filtering by file)

      if (!filterByFile) {

        const filesMap = new Map<string, string>();

        const legacyRecordsCount = records.filter((r: DataFinalRecord) => !r.uploadTask?.id).length;

        

        records.forEach((r: DataFinalRecord) => {

          if (r.uploadTask?.id && r.uploadTask?.fileName) {

            filesMap.set(r.uploadTask.id, r.uploadTask.fileName);

          }

        });

        

        const uniqueFiles = Array.from(filesMap.entries()).map(([id, fileName]) => ({ id, fileName }));

        

        // Add legacy records option if there are any

        if (legacyRecordsCount > 0) {

          uniqueFiles.unshift({ id: 'legacy', fileName: `Legacy Records (${legacyRecordsCount})` });

        }

        

        setUploadFiles(uniqueFiles);

      }

      

      setError('');

    } catch (err: any) {

      console.error('Error fetching data:', err);

      setError(err.response?.data?.message || 'Failed to fetch data');

    } finally {

      setLoading(false);

    }

  };



  const handleView = (record: DataFinalRecord) => {

    setSelectedRecord(record);

    setShowViewDialog(true);

  };



  const handleEdit = (record: DataFinalRecord) => {

    setSelectedRecord(record);

    setEditFormData({

      publisherEmail: record.publisherEmail || '',

      publisherName: record.publisherName || '',

      publisherMatched: record.publisherMatched || false,

      contactName: record.contactName || '',

      contactEmail: record.contactEmail || '',

      da: record.da?.toString() || '',

      dr: record.dr?.toString() || '',

      traffic: record.traffic?.toString() || '',

      ss: record.ss?.toString() || '',

      keywords: record.keywords?.toString() || '',

      domainAge: record.domainAge ? String(record.domainAge).replace(/[^0-9]/g, '') : '',

      category: record.category || '',

      country: record.country || '',

      language: record.language || '',

      tat: record.tat || '',

      gbBasePrice: record.gbBasePrice?.toString() || '',

      liBasePrice: record.liBasePrice?.toString() || '',

      status: record.status,

      negotiationStatus: record.negotiationStatus,

      imageLink: record.imageLink || ''

    });

    // Find matching publisher from list

    const matchingPublisher = publishers.find(p => 

      p.email?.toLowerCase() === record.publisherEmail?.toLowerCase()

    );

    setSelectedPublisher(matchingPublisher || null);

    setShowEditDialog(true);

  };



  const handleDelete = async (id: string) => {

    if (!window.confirm('Are you sure you want to delete this record?')) {

      return;

    }



    try {

      const token = localStorage.getItem('token');

      await axios.delete(`${API_BASE_URL}/data-final/${id}`, {

        headers: {

          Authorization: `Bearer ${token}`

        }

      });



      setData(data.filter(item => item.id !== id));

      showToast('Record deleted successfully', 'success');

    } catch (err: any) {

      console.error('Error deleting record:', err);

      showToast(err.response?.data?.message || 'Failed to delete record', 'error');

    }

  };



  const handleSaveEdit = async () => {

    if (!selectedRecord) return;



    setSaving(true);

    try {

      const token = localStorage.getItem('token');

      

      // Prepare update data - Contributor can update negotiationStatus, contactName, contactEmail, and prices

      const updateData = user?.role === 'CONTRIBUTOR' ? {

        negotiationStatus: editFormData.negotiationStatus,

        contactName: editFormData.contactName,

        contactEmail: editFormData.contactEmail,

        gbBasePrice: editFormData.gbBasePrice ? parseFloat(editFormData.gbBasePrice) : undefined,

        liBasePrice: editFormData.liBasePrice ? parseFloat(editFormData.liBasePrice) : undefined

      } : {

        publisherEmail: editFormData.publisherEmail,

        publisherName: editFormData.publisherName,

        contactName: editFormData.contactName,

        contactEmail: editFormData.contactEmail,

        da: editFormData.da ? parseInt(editFormData.da) : undefined,

        dr: editFormData.dr ? parseInt(editFormData.dr) : undefined,

        traffic: editFormData.traffic ? parseInt(editFormData.traffic) : undefined,

        ss: editFormData.ss ? parseInt(editFormData.ss) : undefined,

        keywords: editFormData.keywords ? parseInt(editFormData.keywords) : undefined,

        domainAge: editFormData.domainAge
          ? String(editFormData.domainAge).replace(/[^0-9]/g, '').slice(0, 64) || undefined
          : undefined,

        category: editFormData.category,

        country: editFormData.country,

        language: editFormData.language,

        tat: editFormData.tat,

        gbBasePrice: editFormData.gbBasePrice ? parseFloat(editFormData.gbBasePrice) : undefined,

        liBasePrice: editFormData.liBasePrice ? parseFloat(editFormData.liBasePrice) : undefined,

        status: editFormData.status,

        negotiationStatus: editFormData.negotiationStatus,

        imageLink: editFormData.imageLink?.trim() || undefined

      };



      const response = await axios.put(

        `${API_BASE_URL}/data-final/${selectedRecord.id}`,

        updateData,

        {

          headers: {

            Authorization: `Bearer ${token}`

          }

        }

      );



      if (response.data.success) {

        // Update the record in the list

        setData(data.map(item => 

          item.id === selectedRecord.id 

            ? { ...item, ...updateData }

            : item

        ));

        showToast('Record updated successfully', 'success');

        setShowEditDialog(false);

        setSelectedRecord(null);

      }

    } catch (err: any) {

      console.error('Error updating record:', err);

      showToast(err.response?.data?.message || 'Failed to update record', 'error');

    } finally {

      setSaving(false);

    }

  };



  // Handle marking contact info as publisher

  const handleCreatePublisher = async () => {

    if (!createPublisherRecord) return;

    

    const name = createPublisherRecord.contactName;

    const email = createPublisherRecord.contactEmail;

    

    if (!name && !email) {

      showToast('No contact information available to mark as publisher', 'warning');

      return;

    }

    

    setCreatingPublisher(true);

    try {

      const token = localStorage.getItem('token');

      const response = await axios.post(

        `${API_BASE_URL}/publishers`,

        {

          name: name || email?.split('@')[0] || 'Unknown',

          email: email,

          dataFinalId: createPublisherRecord.id

        },

        { headers: { Authorization: `Bearer ${token}` } }

      );

      

      if (response.data.success) {

        const publisherName = response.data.data.publisherName;

        const publisherEmail = response.data.data.email || '';

        

        // Update the record in the list

        setData(data.map(item => 

          item.id === createPublisherRecord.id 

            ? { 

                ...item, 

                publisherId: response.data.data.id,

                publisherName: publisherName,

                publisherEmail: publisherEmail,

                publisherMatched: true

              }

            : item

        ));

        

        // Also update editFormData if we're editing this record

        setEditFormData(prev => ({

          ...prev,

          publisherName: publisherName,

          publisherEmail: publisherEmail,

          publisherMatched: true

        }));

        

        setSuccess(`Marked as Publisher: "${publisherName}". When you push this record to the LM Tool, the publisher will be created or linked automatically.`);

        setShowCreatePublisherDialog(false);

        setCreatePublisherRecord(null);

        

        // Refresh data from backend to ensure consistency

        fetchData();

        invalidatePublishersCache();
        fetchPublishers(true);

      }

    } catch (err: any) {

      console.error('Error marking as publisher:', err);

      showToast(err.response?.data?.error || 'Failed to mark as publisher', 'error');

    } finally {

      setCreatingPublisher(false);

    }

  };



  const handleSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {

    if (event.target.checked) {

      const allIds = new Set(data.map(record => record.id));

      setSelectedIds(allIds);

    } else {

      setSelectedIds(new Set());

    }

  };



  const handleSelectOne = (id: string) => {

    const newSelected = new Set(selectedIds);

    if (newSelected.has(id)) {

      newSelected.delete(id);

    } else {

      newSelected.add(id);

    }

    setSelectedIds(newSelected);

  };



  const handleBulkDelete = async () => {

    if (selectedIds.size === 0) {

      setError('Please select at least one record to delete');

      return;

    }



    if (!window.confirm(`Are you sure you want to delete ${selectedIds.size} record(s)?`)) {

      return;

    }



    setDeleting(true);

    setError('');

    

    try {

      const token = localStorage.getItem('token');

      const deletePromises = Array.from(selectedIds).map(id =>

        axios.delete(`${API_BASE_URL}/data-final/${id}`, {

          headers: { Authorization: `Bearer ${token}` }

        })

      );



      await Promise.all(deletePromises);

      

      setSuccess(`Successfully deleted ${selectedIds.size} record(s)`);

      setSelectedIds(new Set());

      fetchData();

    } catch (err: any) {

      console.error('Error deleting records:', err);

      setError(err.response?.data?.message || 'Failed to delete records');

    } finally {

      setDeleting(false);

    }

  };



  const handleExportFiltered = async () => {

    if (data.length === 0) {

      setError('No records to export');

      return;

    }



    setExporting(true);

    try {

      const token = localStorage.getItem('token');

      const params = new URLSearchParams();

      if (filterByUser !== 'all') params.append('reachedBy', filterByUser);

      if (filterByPublisher) params.append('publisher', filterByPublisher);

      if (filterByFile) params.append('uploadTaskId', filterByFile);

      if (filterByStatus) params.append('status', filterByStatus);



      const response = await axios.get(

        `${API_BASE_URL}/data-final/export${params.toString() ? '?' + params.toString() : ''}`,

        {

          headers: { Authorization: `Bearer ${token}` },

          responseType: 'blob'

        }

      );



      const url = window.URL.createObjectURL(new Blob([response.data]));

      const link = document.createElement('a');

      link.href = url;

      const fileName = `data_final_${new Date().toISOString().split('T')[0]}.csv`;

      link.setAttribute('download', fileName);

      document.body.appendChild(link);

      link.click();

      link.remove();

      window.URL.revokeObjectURL(url);



      setSuccess(`Exported ${data.length} record(s) successfully`);

    } catch (err: any) {

      console.error('Error exporting data:', err);

      setError(err.response?.data?.message || 'Failed to export data');

    } finally {

      setExporting(false);

    }

  };



  const handleImportClick = () => {

    fileInputRef.current?.click();

  };



  const handleFileSelect = async (event: React.ChangeEvent<HTMLInputElement>) => {

    const file = event.target.files?.[0];

    if (!file) return;



    if (!file.name.endsWith('.csv')) {

      setError('Please select a CSV file');

      return;

    }



    setImporting(true);

    setError('');

    try {

      const token = localStorage.getItem('token');

      const formData = new FormData();

      formData.append('file', file);



      const response = await axios.post(

        `${API_BASE_URL}/upload/csv`,

        formData,

        {

          headers: {

            Authorization: `Bearer ${token}`,

            'Content-Type': 'multipart/form-data'

          }

        }

      );



      if (response.data.success) {

        const summary = response.data.data.summary;

        if (summary.priceUpdates > 0) {

          setSuccess(`Successfully updated ${summary.priceUpdates} record(s) with new prices`);

        } else if (summary.uniqueRows > 0) {

          setSuccess(`Successfully imported ${summary.uniqueRows} new record(s)`);

        } else {

          setError('No records were updated or imported');

        }

        fetchData();

      } else {

        setError(response.data.message || 'Import failed');

      }

    } catch (err: any) {

      console.error('Error importing file:', err);

      setError(err.response?.data?.error?.message || err.response?.data?.message || 'Failed to import file');

    } finally {

      setImporting(false);

      if (fileInputRef.current) {

        fileInputRef.current.value = '';

      }

    }

  };



  const handlePushSelected = async () => {

    if (selectedIds.size === 0) return;

    

    // Check if all selected records have GB Base Price

    const selectedRecords = data.filter(d => selectedIds.has(d.id));

    const recordsWithoutPrice = selectedRecords.filter(r => !r.gbBasePrice || r.gbBasePrice <= 0);

    

    if (recordsWithoutPrice.length > 0) {

      const siteUrls = recordsWithoutPrice.map(r => r.websiteUrl).join('\n- ');

      setError(`GB Base Price is required before pushing to LM Tool. The following sites are missing GB Base Price:\n- ${siteUrls}`);

      return;

    }

    

    // Check if all selected records have publisher email (either from matched publisher or contact)

    const recordsWithoutPublisher = selectedRecords.filter(r => 

      !r.publisherEmail && !r.contactEmail

    );

    

    if (recordsWithoutPublisher.length > 0) {

      const siteUrls = recordsWithoutPublisher.map(r => r.websiteUrl).join('\n- ');

      setError(`Publisher/Contact Email is required before pushing to LM Tool. The following sites are missing email:\n- ${siteUrls}`);

      return;

    }

    

    if (!window.confirm(`Push ${selectedIds.size} site(s) to LM Tool?`)) {

      return;

    }

    

    setPushing(true);

    setError('');

    try {

      const token = localStorage.getItem('token');

      const response = await axios.post(

        `${API_BASE_URL}/data-final/push-to-main-project`,

        { recordIds: Array.from(selectedIds) },

        { headers: { Authorization: `Bearer ${token}` } }

      );

      

      const result = response.data.data;

      

      // Use the detailed message from backend

      let message = result.message || `Pushed ${result.successful} site(s) to LM Tool.`;

      

      // Show skipped site details if available

      if (result.details?.skipped && result.details.skipped.length > 0) {

        const skippedDetails = result.details.skipped.map((s: any) => `${s.site_url}: ${s.reason}`).join('\n');

      }

      

      if (result.failed > 0) {

        message += ` ${result.failed} failed.`;

      }

      

      setSuccess(message);

      setSelectedIds(new Set());

      fetchData();

      

      // Navigate to Pushed Data page after 2 seconds

      setTimeout(() => {

        navigate('/pushed-data');

      }, 2000);

    } catch (err: any) {

      setError(err.response?.data?.message || 'Failed to push sites');

      setPushing(false);

    }

  };



  // Handle publisher export

  const handleExportByPublisher = async () => {

    if (!selectedExportPublisher) {

      setError('Please select a publisher to export');

      return;

    }



    setExporting(true);

    setError('');

    try {

      const token = localStorage.getItem('token');

      const selectedPublisher = exportPublishers.find(p => p.email === selectedExportPublisher);

      

      const response = await axios.get(

        `${API_BASE_URL}/data-final/export/publisher?publisherEmail=${encodeURIComponent(selectedExportPublisher)}`,

        {

          headers: { Authorization: `Bearer ${token}` },

          responseType: 'blob'

        }

      );



      // Create download link

      const blob = new Blob([response.data], { type: 'text/csv' });

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');

      link.href = url;

      

      const publisherName = selectedPublisher?.name || 'Unknown';

      const sanitizedName = publisherName.replace(/[^a-zA-Z0-9]/g, '_');

      link.download = `publisher_${sanitizedName}_export_${new Date().toISOString().split('T')[0]}.csv`;

      

      document.body.appendChild(link);

      link.click();

      document.body.removeChild(link);

      window.URL.revokeObjectURL(url);



      setSuccess(`Successfully exported ${selectedPublisher?.recordCount || 0} records for ${publisherName}`);

      setShowExportDialog(false);

      setSelectedExportPublisher('');

    } catch (err: any) {

      console.error('Export error:', err);

      setError(err.response?.data?.message || 'Failed to export data');

    } finally {

      setExporting(false);

    }

  };



  const handlePushAll = async () => {

    const unpushedRecords = data.filter(d => !d.mainProjectId);

    const unpushedCount = unpushedRecords.length;

    

    if (unpushedCount === 0) {

      setError('No unpushed sites to transfer');

      return;

    }

    

    // Check if all unpushed records have GB Base Price

    const recordsWithoutPrice = unpushedRecords.filter(r => !r.gbBasePrice || r.gbBasePrice <= 0);

    

    if (recordsWithoutPrice.length > 0) {

      const siteUrls = recordsWithoutPrice.map(r => r.websiteUrl).join('\n- ');

      setError(`GB Base Price is required before pushing to LM Tool. The following sites are missing GB Base Price:\n- ${siteUrls}`);

      return;

    }

    

    if (!window.confirm(`Push all ${unpushedCount} unpushed site(s) to LM Tool?`)) {

      return;

    }

    

    setPushing(true);

    setError('');

    try {

      const token = localStorage.getItem('token');

      const response = await axios.post(

        `${API_BASE_URL}/data-final/push-to-main-project`,

        { recordIds: [] }, // Empty = all unpushed

        { headers: { Authorization: `Bearer ${token}` } }

      );

      

      const result = response.data.data;

      

      // Use the detailed message from backend

      let message = result.message || `Pushed ${result.successful} site(s) to LM Tool.`;

      

      // Show skipped site details if available

      if (result.details?.skipped && result.details.skipped.length > 0) {

        const skippedDetails = result.details.skipped.map((s: any) => `${s.site_url}: ${s.reason}`).join('\n');

      }

      

      if (result.failed > 0) {

        message += ` ${result.failed} failed.`;

      }

      

      setSuccess(message);

      fetchData();

      

      // Navigate to Pushed Data page after 2 seconds

      setTimeout(() => {

        navigate('/pushed-data');

      }, 2000);

    } catch (err: any) {

      setError(err.response?.data?.message || 'Failed to push sites');

      setPushing(false);

    }

  };



  const getStatusColor = (status: string) => {

    switch (status) {

      case 'EMAIL_SENT':

        return 'success';

      case 'RESPONSE_RECEIVED':

        return 'info';

      case 'FINAL_COST':

        return 'warning';

      case 'ACTIVE':

        return 'success';

      case 'INACTIVE':

        return 'default';

      default:

        return 'default';

    }

  };

  const getFinalStatusHexColor = (status: string) => {
    switch (status) {
      case 'EMAIL_SENT':
      case 'ACTIVE':
      case 'INACTIVE':
        return '#2e7d32';
      case 'RESPONSE_RECEIVED':
        return '#1565c0';
      case 'FINAL_COST':
        return '#6a1b9a';
      default:
        return '#616161';
    }
  };

  const getFinalStatusLabel = (status: string) => {
    switch (status) {
      case 'EMAIL_SENT':
        return 'Email Sent';
      case 'RESPONSE_RECEIVED':
        return 'Response Received';
      case 'FINAL_COST':
        return 'Final Cost';
      case 'ACTIVE':
        return 'Email Sent';
      case 'INACTIVE':
        return 'Email Sent';
      default:
        return status?.replace(/_/g, ' ') || status;
    }
  };

  const getFinalStatusIcon = (status: string, fontSize: 'small' | 'medium' = 'small') => {
    const color = getFinalStatusHexColor(status);
    const sx = { fontSize: fontSize === 'small' ? 18 : 22, color };
    switch (status) {
      case 'EMAIL_SENT':
      case 'ACTIVE':
      case 'INACTIVE':
        return <MarkEmailReadIcon sx={sx} />;
      case 'RESPONSE_RECEIVED':
        return <MarkunreadMailboxIcon sx={sx} />;
      case 'FINAL_COST':
        return <AttachMoneyIcon sx={sx} />;
      default:
        return <MarkEmailReadIcon sx={sx} />;
    }
  };



  const getNegotiationStatusColor = (status: string) => {

    switch (status) {

      case 'IN_PROGRESS':

        return 'warning';

      case 'DONE':

        return 'success';

      default:

        return 'default';

    }

  };



  // Get category label from value

  const getCategoryLabel = (value: string | undefined) => {

    if (!value) return null;

    const category = categories.find(c => c.value === value);

    return category ? category.label : value;

  };



  // Get language label from value

  const getLanguageLabel = (value: string | undefined) => {

    if (!value) return null;

    const language = findLanguageOption(LANGUAGES, value);

    return language ? language.label : value;

  };



  // Get country label from value

  const getCountryLabel = (value: string | undefined) => {

    if (!value) return null;

    const country = findCountryOption(COUNTRIES, value);

    return country ? country.label : value;

  };



  const formatDate = (dateString: string) => {

    return new Date(dateString).toLocaleDateString('en-US', {

      year: 'numeric',

      month: 'short',

      day: 'numeric',

      hour: '2-digit',

      minute: '2-digit'

    });

  };



  // Paginated data

  const handleSort = (column: 'dr' | 'traffic') => {
    if (sortBy === column) {
      setSortOrder((prev) => (prev === 'asc' ? 'desc' : 'asc'));
    } else {
      setSortBy(column);
      setSortOrder('asc');
    }
    setPage(0);
  };

  const sortedData = useMemo(() => {
    if (!sortBy) return data;
    const rows = [...data];
    rows.sort((a, b) => {
      const av = a[sortBy];
      const bv = b[sortBy];
      const aMissing = av == null || av === ('' as unknown);
      const bMissing = bv == null || bv === ('' as unknown);
      if (aMissing && bMissing) return 0;
      if (aMissing) return 1;
      if (bMissing) return -1;
      const diff = Number(av) - Number(bv);
      return sortOrder === 'asc' ? diff : -diff;
    });
    return rows;
  }, [data, sortBy, sortOrder]);

  const paginatedData = sortedData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);



  // Handle page change

  const handleChangePage = (_event: unknown, newPage: number) => {

    setPage(newPage);

  };



  // Handle rows per page change

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {

    setRowsPerPage(parseInt(event.target.value, 10));

    setPage(0);

  };



  return (

    <Box>

      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 2, flexWrap: 'wrap' }}>
        <Box>
      <Typography variant="h4" gutterBottom fontWeight="bold">

        Data Final

      </Typography>

      <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>

        Records marked as Email Sent by Admin users (Super Admin Only)

      </Typography>
        </Box>
        <ColumnVisibilityMenu
          columns={columnOptions}
          visible={visibleColumns}
          onToggle={toggleColumn}
        />
      </Box>



      {error && (

        <Alert severity="error" sx={{ mb: 3 }} onClose={() => setError('')}>

          {error}

        </Alert>

      )}



      {success && (

        <Alert severity="success" sx={{ mb: 3 }} onClose={() => setSuccess('')}>

          {success}

        </Alert>

      )}



      {/* Filter and Export - Inline for Super Admin */}

      {user?.role === 'SUPER_ADMIN' && (

        <Box sx={{ mb: 3, display: 'flex', gap: 1.5, alignItems: 'center', flexWrap: 'wrap' }}>

          <TextField
            size="small"
            label="Search site URL"
            placeholder="Type to search..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            sx={{ width: 260, minWidth: 260 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" color="action" />
                </InputAdornment>
              ),
              endAdornment: searchText ? (
                <InputAdornment position="end">
                  <IconButton size="small" onClick={() => setSearchText('')} edge="end" aria-label="clear search">
                    <ClearIcon fontSize="small" />
                  </IconButton>
                </InputAdornment>
              ) : undefined
            }}
          />

          <Autocomplete
            size="small"
            options={[
              { id: 'all', label: 'All Users' },
              ...users.map((u) => ({
                id: u.id,
                label: `${u.firstName} ${u.lastName}`.trim()
              }))
            ]}
            value={
              filterByUser === 'all'
                ? { id: 'all', label: 'All Users' }
                : users
                    .map((u) => ({ id: u.id, label: `${u.firstName} ${u.lastName}`.trim() }))
                    .find((o) => o.id === filterByUser) || { id: 'all', label: 'All Users' }
            }
            onChange={(_, option) => setFilterByUser(option?.id || 'all')}
            getOptionLabel={(option) => option.label}
            isOptionEqualToValue={(a, b) => a.id === b.id}
            renderInput={(params) => (
              <TextField {...params} label="Completed By" placeholder="Search user..." />
            )}
            sx={{ width: 260, minWidth: 260 }}
          />

          <Autocomplete
            size="small"
            options={[
              { id: '', label: 'All Publishers' },
              ...allPublisherEmails.map((email) => ({ id: email, label: email }))
            ]}
            value={
              !filterByPublisher
                ? { id: '', label: 'All Publishers' }
                : { id: filterByPublisher, label: filterByPublisher }
            }
            onChange={(_, option) => setFilterByPublisher(option?.id || '')}
            getOptionLabel={(option) => option.label}
            isOptionEqualToValue={(a, b) => a.id === b.id}
            renderInput={(params) => (
              <TextField {...params} label="Publisher / Contact" placeholder="Search publisher..." />
            )}
            sx={{ width: 260, minWidth: 260 }}
          />

          <Autocomplete
            size="small"
            options={[
              { id: '', label: 'All Statuses' },
              { id: 'EMAIL_SENT', label: 'Email Sent' },
              { id: 'RESPONSE_RECEIVED', label: 'Response Received' },
              { id: 'FINAL_COST', label: 'Final Cost' }
            ]}
            value={
              !filterByStatus
                ? { id: '', label: 'All Statuses' }
                : [
                    { id: 'EMAIL_SENT', label: 'Email Sent' },
                    { id: 'RESPONSE_RECEIVED', label: 'Response Received' },
                    { id: 'FINAL_COST', label: 'Final Cost' }
                  ].find((o) => o.id === filterByStatus) || { id: '', label: 'All Statuses' }
            }
            onChange={(_, option) => setFilterByStatus(option?.id || '')}
            getOptionLabel={(option) => option.label}
            isOptionEqualToValue={(a, b) => a.id === b.id}
            renderInput={(params) => (
              <TextField {...params} label="Status" placeholder="Filter by status..." />
            )}
            sx={{ width: 240, minWidth: 240 }}
          />

          <Autocomplete
            size="small"
            options={[
              { id: '', label: 'All Files' },
              ...uploadFiles.map((file) => ({ id: file.id, label: file.fileName }))
            ]}
            value={
              !filterByFile
                ? { id: '', label: 'All Files' }
                : uploadFiles
                    .map((file) => ({ id: file.id, label: file.fileName }))
                    .find((o) => o.id === filterByFile) || { id: '', label: 'All Files' }
            }
            onChange={(_, option) => setFilterByFile(option?.id || '')}
            getOptionLabel={(option) => option.label}
            isOptionEqualToValue={(a, b) => a.id === b.id}
            renderInput={(params) => (
              <TextField {...params} label="Import File" placeholder="Search file..." />
            )}
            sx={{ width: 260, minWidth: 260 }}
          />

          {(filterByUser !== 'all' || filterByPublisher || filterByFile || filterByStatus || searchText) && (

            <Button

              variant="outlined"

              size="small"

              onClick={() => {

                setFilterByUser('all');

                setFilterByPublisher('');

                setFilterByFile('');

                setFilterByStatus('');

                setSearchText('');

              }}

              startIcon={<ClearIcon fontSize="small" />}

              sx={{ height: 40 }}

            >

              Clear All

            </Button>

          )}



          {/* Export and Import Buttons - Inline */}

          {data.length > 0 && (

            <Box sx={{ display: 'flex', gap: 1 }}>

              <Button

                variant="contained"

                size="small"

                onClick={handleExportFiltered}

                disabled={exporting}

                startIcon={exporting ? <CircularProgress size={16} /> : <span>📥</span>}

                sx={{

                  backgroundColor: '#2e7d32',

                  color: '#ffffff',

                  '&:hover': {

                    backgroundColor: '#1b5e20',

                  },

                  '&:disabled': {

                    backgroundColor: '#a5d6a7',

                    color: '#ffffff',

                  }

                }}

              >

                {exporting ? 'Exporting...' : 'Export Filtered'}

              </Button>

              <Button

                variant="contained"

                size="small"

                onClick={handleImportClick}

                disabled={importing}

                startIcon={importing ? <CircularProgress size={16} /> : <span>📤</span>}

                sx={{

                  backgroundColor: '#1976d2',

                  color: '#ffffff',

                  '&:hover': {

                    backgroundColor: '#1565c0',

                  },

                  '&:disabled': {

                    backgroundColor: '#90caf9',

                    color: '#ffffff',

                  }

                }}

              >

                {importing ? 'Importing...' : 'Import CSV'}

              </Button>

              <input

                type="file"

                ref={fileInputRef}

                onChange={handleFileSelect}

                accept=".csv"

                style={{ display: 'none' }}

              />

            </Box>

          )}



          {/* Export by Publisher Button - Temporarily Hidden */}

          {/* {data.length > 0 && exportPublishers.length > 0 && (
            <Button
              variant="outlined"
              color="info"
              size="small"
              onClick={() => setShowExportDialog(true)}
              startIcon={<span>📊</span>}
            >
              Export by Publisher
            </Button>
          )} */}

        </Box>

      )}



      {/* Filter for CONTRIBUTOR - Show file filter, export and import */}

      {user?.role === 'CONTRIBUTOR' && (

        <Box sx={{ mb: 3, display: 'flex', gap: 1.5, alignItems: 'center', flexWrap: 'wrap' }}>

          <Autocomplete
            size="small"
            options={[
              { id: '', label: 'All Files' },
              ...uploadFiles.map((file) => ({ id: file.id, label: file.fileName }))
            ]}
            value={
              !filterByFile
                ? { id: '', label: 'All Files' }
                : uploadFiles
                    .map((file) => ({ id: file.id, label: file.fileName }))
                    .find((o) => o.id === filterByFile) || { id: '', label: 'All Files' }
            }
            onChange={(_, option) => setFilterByFile(option?.id || '')}
            getOptionLabel={(option) => option.label}
            isOptionEqualToValue={(a, b) => a.id === b.id}
            renderInput={(params) => (
              <TextField {...params} label="Import File" placeholder="Search file..." />
            )}
            sx={{ width: 260, minWidth: 260 }}
          />

          {filterByFile && (

            <Button

              variant="outlined"

              size="small"

              onClick={() => setFilterByFile('')}

              startIcon={<ClearIcon fontSize="small" />}

              sx={{ height: 40 }}

            >

              Clear Filter

            </Button>

          )}



          {/* Export and Import Buttons for CONTRIBUTOR - Inline */}

          {data.length > 0 && (

            <Box sx={{ display: 'flex', gap: 1 }}>

              <Button

                variant="contained"

                size="small"

                onClick={handleExportFiltered}

                disabled={exporting}

                startIcon={exporting ? <CircularProgress size={16} /> : <span>📥</span>}

                sx={{

                  backgroundColor: '#2e7d32',

                  color: '#ffffff',

                  '&:hover': {

                    backgroundColor: '#1b5e20',

                  },

                  '&:disabled': {

                    backgroundColor: '#a5d6a7',

                    color: '#ffffff',

                  }

                }}

              >

                {exporting ? 'Exporting...' : 'Export Filtered'}

              </Button>

              

              <Button

                variant="contained"

                size="small"

                onClick={handleImportClick}

                disabled={importing}

                startIcon={importing ? <CircularProgress size={16} /> : <span>📤</span>}

                sx={{

                  backgroundColor: '#1976d2',

                  color: '#ffffff',

                  '&:hover': {

                    backgroundColor: '#1565c0',

                  },

                  '&:disabled': {

                    backgroundColor: '#90caf9',

                    color: '#ffffff',

                  }

                }}

              >

                {importing ? 'Importing...' : 'Import CSV'}

              </Button>

              

              <input

                type="file"

                ref={fileInputRef}

                onChange={handleFileSelect}

                accept=".csv"

                style={{ display: 'none' }}

              />

            </Box>

          )}

        </Box>

      )}



      <Card>

        <CardContent>

          {/* Push Buttons */}

          <Box sx={{ mb: 2, display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'center' }}>

            {selectedIds.size > 0 && (

              <>

                <Button

                  variant="contained"

                  color="primary"

                  size="small"

                  onClick={handlePushSelected}

                  disabled={pushing}

                >

                  {pushing ? '⏳ Pushing...' : `📤 Push ${selectedIds.size} to LM Tool`}

                </Button>

                <Button

                  variant="contained"

                  color="error"

                  size="small"

                  startIcon={<DeleteIcon />}

                  onClick={handleBulkDelete}

                  disabled={deleting}

                >

                  {deleting ? 'Deleting...' : 'Delete Selected'}

                </Button>

                <Typography variant="body2" sx={{ alignSelf: 'center', ml: 1 }}>

                  {selectedIds.size} record(s) selected

                </Typography>

              </>

            )}

            

            <Button

              variant="outlined"

              color="primary"

              size="small"

              onClick={handlePushAll}

              disabled={pushing || data.filter(d => !d.mainProjectId).length === 0}

            >

              📤 Push All to LM Tool

            </Button>

          </Box>



          {loading ? (

            <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>

              <CircularProgress />

            </Box>

          ) : data.length === 0 ? (

            <Box sx={{ textAlign: 'center', py: 8 }}>

              <Typography variant="body1" color="text.secondary">

                No records in Data Final yet. Records will appear here when Admins mark them as Email Sent.

              </Typography>

            </Box>

          ) : (

            <TableContainer>

              <Table>

                <TableHead>

                  <TableRow>

                    <TableCell padding="checkbox">

                      <Checkbox

                        checked={selectedIds.size === data.length && data.length > 0}

                        indeterminate={selectedIds.size > 0 && selectedIds.size < data.length}

                        onChange={handleSelectAll}

                      />

                    </TableCell>

                    <TableCell align="center" sx={{ width: 50 }}><strong>Edit</strong></TableCell>

                    <TableCell><strong>Site URL</strong></TableCell>

                    {showCol('imageLink') && <TableCell align="center"><strong>Image Link</strong></TableCell>}

                    {showCol('publisher') && <TableCell><strong>Publisher / Contact</strong></TableCell>}

                    {user?.role === 'SUPER_ADMIN' && showCol('email') && <TableCell><strong>Email</strong></TableCell>}

                    {showCol('da') && <TableCell><strong>DA</strong></TableCell>}

                    {showCol('dr') && (
                    <TableCell>
                      <TableSortLabel
                        active={sortBy === 'dr'}
                        direction={sortBy === 'dr' ? sortOrder : 'asc'}
                        onClick={() => handleSort('dr')}
                      >
                        <strong>DR</strong>
                      </TableSortLabel>
                    </TableCell>
                    )}

                    {showCol('traffic') && (
                    <TableCell>
                      <TableSortLabel
                        active={sortBy === 'traffic'}
                        direction={sortBy === 'traffic' ? sortOrder : 'asc'}
                        onClick={() => handleSort('traffic')}
                      >
                        <strong>Traffic</strong>
                      </TableSortLabel>
                    </TableCell>
                    )}

                    {showCol('ss') && <TableCell><strong>SS</strong></TableCell>}

                    {showCol('keywords') && <TableCell><strong>Keywords</strong></TableCell>}
                    {showCol('domainAge') && <TableCell><strong>Domain Age</strong></TableCell>}

                    {showCol('category') && <TableCell><strong>Category</strong></TableCell>}

                    {showCol('country') && <TableCell><strong>Country</strong></TableCell>}

                    {showCol('language') && <TableCell><strong>Language</strong></TableCell>}

                    {showCol('tat') && <TableCell><strong>TAT</strong></TableCell>}

                    {showCol('gbPrice') && <TableCell><strong>GB Base Price</strong></TableCell>}

                    {showCol('liPrice') && <TableCell><strong>LI Base Price</strong></TableCell>}

                    {showCol('status') && <TableCell><strong>Status</strong></TableCell>}

                    {showCol('negotiation') && <TableCell><strong>Negotiation Status</strong></TableCell>}

                    {user?.role !== 'CONTRIBUTOR' && showCol('markedBy') && <TableCell><strong>Marked As Email Sent By</strong></TableCell>}

                    {showCol('createdAt') && <TableCell><strong>Created Date</strong></TableCell>}

                    <TableCell align="center"><strong>Actions</strong></TableCell>

                  </TableRow>

                </TableHead>

                <TableBody>

                  {paginatedData.map((row) => (

                    <TableRow key={row.id} hover>

                      <TableCell padding="checkbox">

                        <Checkbox

                          checked={selectedIds.has(row.id)}

                          onChange={() => handleSelectOne(row.id)}

                        />

                      </TableCell>

                      <TableCell align="center" sx={{ width: 50 }}>

                        <Tooltip title="Edit">

                          <IconButton 

                            size="small" 

                            color="primary"

                            onClick={() => handleEdit(row)}

                          >

                            <EditIcon fontSize="small" />

                          </IconButton>

                        </Tooltip>

                      </TableCell>

                      <TableCell>

                        <Typography 

                          variant="body2" 

                          component="a"

                          href={row.websiteUrl.startsWith('http') ? row.websiteUrl : `https://${row.websiteUrl}`}

                          target="_blank"

                          rel="noopener noreferrer"

                          sx={{ 

                            fontFamily: 'monospace', 

                            fontWeight: 'bold',

                            color: 'primary.main',

                            textDecoration: 'none',

                            '&:hover': {

                              textDecoration: 'underline'

                            }

                          }}

                        >

                          {row.websiteUrl}

                        </Typography>

                      </TableCell>

                      {showCol('imageLink') && (
                      <TableCell align="center">
                        {row.imageLink ? (
                          <Tooltip title={row.imageLink}>
                            <IconButton
                              size="small"
                              component="a"
                              href={row.imageLink.startsWith('http') ? row.imageLink : `https://${row.imageLink}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              color="primary"
                            >
                              <LinkIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        ) : (
                          <Typography variant="caption" color="text.secondary">—</Typography>
                        )}
                      </TableCell>
                      )}

                      {showCol('publisher') && (
                      <TableCell>

                        {row.publisherMatched ? (

                          <Box>

                            <Typography variant="body2">{row.publisherName}</Typography>

                            <Typography variant="caption" color="success.main">✓ Publisher</Typography>

                          </Box>

                        ) : row.contactName || row.contactEmail ? (

                          <Box>

                            <Typography variant="body2">{row.contactName || 'No name'}</Typography>

                            <Typography variant="caption" color="info.main">Contact</Typography>

                          </Box>

                        ) : (

                          <Typography variant="caption" color="text.secondary">Not set</Typography>

                        )}

                      </TableCell>
                      )}

                      {user?.role === 'SUPER_ADMIN' && showCol('email') && (

                        <TableCell>

                          {row.publisherMatched ? (

                            row.publisherEmail || <Typography variant="caption" color="text.secondary">-</Typography>

                          ) : (

                            row.contactEmail || <Typography variant="caption" color="text.secondary">-</Typography>

                          )}

                        </TableCell>

                      )}

                      {showCol('da') && (
                      <TableCell>

                        {row.da || <Typography variant="caption" color="text.secondary">-</Typography>}

                      </TableCell>
                      )}

                      {showCol('dr') && (
                      <TableCell>

                        {row.dr || <Typography variant="caption" color="text.secondary">-</Typography>}

                      </TableCell>
                      )}

                      {showCol('traffic') && (
                      <TableCell>

                        {row.traffic || <Typography variant="caption" color="text.secondary">-</Typography>}

                      </TableCell>
                      )}

                      {showCol('ss') && (
                      <TableCell>

                        {row.ss || <Typography variant="caption" color="text.secondary">-</Typography>}

                      </TableCell>
                      )}

                      {showCol('keywords') && (
                      <TableCell>

                        {row.keywords || <Typography variant="caption" color="text.secondary">-</Typography>}

                      </TableCell>
                      )}

                      {showCol('domainAge') && (
                      <TableCell>

                        {row.domainAge != null && String(row.domainAge).trim() !== ''
                          ? `${String(row.domainAge).replace(/[^0-9]/g, '')} years`
                          : <Typography variant="caption" color="text.secondary">-</Typography>}

                      </TableCell>
                      )}

                      {showCol('category') && (
                      <TableCell>

                        {getCategoryLabel(row.category) || <Typography variant="caption" color="text.secondary">Not set</Typography>}

                      </TableCell>
                      )}

                      {showCol('country') && (
                      <TableCell>

                        {getCountryLabel(row.country) || <Typography variant="caption" color="text.secondary">Not set</Typography>}

                      </TableCell>
                      )}

                      {showCol('language') && (
                      <TableCell>

                        {getLanguageLabel(row.language) || <Typography variant="caption" color="text.secondary">Not set</Typography>}

                      </TableCell>
                      )}

                      {showCol('tat') && (
                      <TableCell>

                        {row.tat || <Typography variant="caption" color="text.secondary">Not set</Typography>}

                      </TableCell>
                      )}

                      {showCol('gbPrice') && (
                      <TableCell>

                        {row.gbBasePrice ? `$${row.gbBasePrice}` : <Typography variant="caption" color="text.secondary">Not set</Typography>}

                      </TableCell>
                      )}

                      {showCol('liPrice') && (
                      <TableCell>

                        {row.liBasePrice ? `$${row.liBasePrice}` : <Typography variant="caption" color="text.secondary">Not set</Typography>}

                      </TableCell>
                      )}

                      {showCol('status') && (
                      <TableCell>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
                          {getFinalStatusIcon(row.status)}
                          <Chip 
                            label={getFinalStatusLabel(row.status)} 
                            color={getStatusColor(row.status) as any}
                            size="small"
                            sx={{ color: '#fff', fontWeight: 600 }}
                          />
                        </Box>
                      </TableCell>
                      )}

                      {showCol('negotiation') && (
                      <TableCell>

                        <Chip 

                          label={row.negotiationStatus.replace('_', ' ')} 

                          color={getNegotiationStatusColor(row.negotiationStatus) as any}

                          size="small"

                          sx={{ color: '#fff', fontWeight: 600 }}

                        />

                      </TableCell>
                      )}

                      {user?.role !== 'CONTRIBUTOR' && showCol('markedBy') && (

                        <TableCell>

                          {row.reachedByUser ? (

                            <Box>

                              <Typography 

                                variant="body2" 

                                sx={{ 

                                  color: 'primary.main',

                                  fontWeight: 500

                                }}

                              >

                                {row.reachedByUser.firstName}

                              </Typography>

                              <Typography 

                                variant="caption" 

                                sx={{ 

                                  fontSize: '0.7rem',

                                  color: 'text.secondary',

                                  display: 'block'

                                }}

                              >

                                {row.reachedByUser.role === 'SUPER_ADMIN' ? 'Super Admin' : 'Admin'}

                              </Typography>

                            </Box>

                          ) : (

                            <Typography variant="caption" color="text.secondary">

                              {row.reachedByName || 'Unknown'}

                            </Typography>

                          )}

                        </TableCell>

                      )}

                      {showCol('createdAt') && (
                      <TableCell>

                        <Typography variant="body2">

                          {new Date(row.createdAt).toLocaleDateString('en-US', {

                            year: 'numeric',

                            month: 'short',

                            day: 'numeric'

                          })}

                        </Typography>

                        <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>

                          {new Date(row.createdAt).toLocaleTimeString('en-US', {

                            hour: '2-digit',

                            minute: '2-digit'

                          })}

                        </Typography>

                      </TableCell>
                      )}

                      <TableCell align="center">

                        <Tooltip title="View Details">

                          <IconButton 

                            size="small" 

                            color="info"

                            onClick={() => handleView(row)}

                          >

                            <RemoveRedEyeIcon fontSize="small" />

                          </IconButton>

                        </Tooltip>

                        <Tooltip title="Delete">

                          <IconButton 

                            size="small" 

                            color="error"

                            onClick={() => handleDelete(row.id)}

                            sx={{ ml: 1 }}

                          >

                            <DeleteIcon fontSize="small" />

                          </IconButton>

                        </Tooltip>

                        {/* Mark as Publisher button - only for Super Admin and records with contact info but no matched publisher */}

                        {user?.role === 'SUPER_ADMIN' && !row.publisherMatched && (row.contactName || row.contactEmail) && (

                          <Tooltip title="Mark as Publisher">

                            <Button

                              size="small"

                              variant="outlined"

                              color="info"

                              onClick={() => {

                                setCreatePublisherRecord(row);

                                setShowCreatePublisherDialog(true);

                              }}

                              sx={{ ml: 1, minWidth: 'auto', px: 1 }}

                            >

                              Mark Publisher

                            </Button>

                          </Tooltip>

                        )}

                      </TableCell>

                    </TableRow>

                  ))}

                </TableBody>

              </Table>

            </TableContainer>

          )}

          

          {/* Pagination - show when data exists */}

          {data.length > 0 && (

            <TablePagination

              component="div"

              count={data.length}

              page={page}

              onPageChange={handleChangePage}

              rowsPerPage={rowsPerPage}

              onRowsPerPageChange={handleChangeRowsPerPage}

              rowsPerPageOptions={[25, 50, 100, 250, 500]}

              showFirstButton

              showLastButton

            />

          )}

        </CardContent>

      </Card>



      {/* View Dialog */}

      <Dialog open={showViewDialog} onClose={() => setShowViewDialog(false)} maxWidth="md" fullWidth>

        <DialogTitle>View Record Details</DialogTitle>

        <DialogContent sx={{ mt: 2 }}>

          {selectedRecord && (

            <Grid container spacing={2}>

              <Grid item xs={12}>

                <TextField

                  fullWidth

                  label="Website URL"

                  value={selectedRecord.websiteUrl}

                  InputProps={{ readOnly: true }}

                />

              </Grid>

              {selectedRecord.publisherMatched ? (

                <>

                  <Grid item xs={12}>

                    <Alert severity="success">

                      {selectedRecord.publisherId?.startsWith('pending_')

                        ? 'Publisher will be created in the LM Tool when you push this record.'

                        : 'Publisher matched from LM Tool'}

                    </Alert>

                  </Grid>

                  <Grid item xs={6}>

                    <TextField

                      fullWidth

                      label="Publisher Name"

                      value={selectedRecord.publisherName || ''}

                      InputProps={{ readOnly: true }}

                    />

                  </Grid>

                  <Grid item xs={6}>

                    <TextField

                      fullWidth

                      label="Publisher Email"

                      value={selectedRecord.publisherEmail || ''}

                      InputProps={{ readOnly: true }}

                    />

                  </Grid>

                </>

              ) : (

                <>

                  <Grid item xs={6}>

                    <TextField

                      fullWidth

                      label="Contact Name"

                      value={selectedRecord.contactName || ''}

                      InputProps={{ readOnly: true }}

                    />

                  </Grid>

                  <Grid item xs={6}>

                    <TextField

                      fullWidth

                      label="Contact Email"

                      value={selectedRecord.contactEmail || ''}

                      InputProps={{ readOnly: true }}

                    />

                  </Grid>

                </>

              )}

              <Grid item xs={3}>

                <TextField

                  fullWidth

                  label="DA"

                  value={selectedRecord.da || '-'}

                  InputProps={{ readOnly: true }}

                />

              </Grid>

              <Grid item xs={3}>

                <TextField

                  fullWidth

                  label="DR"

                  value={selectedRecord.dr || '-'}

                  InputProps={{ readOnly: true }}

                />

              </Grid>

              <Grid item xs={3}>

                <TextField

                  fullWidth

                  label="Traffic"

                  value={selectedRecord.traffic || '-'}

                  InputProps={{ readOnly: true }}

                />

              </Grid>

              <Grid item xs={3}>

                <TextField

                  fullWidth

                  label="SS"

                  value={selectedRecord.ss || '-'}

                  InputProps={{ readOnly: true }}

                />

              </Grid>

              <Grid item xs={3}>

                <TextField

                  fullWidth

                  label="Keywords"

                  value={selectedRecord.keywords || '-'}

                  InputProps={{ readOnly: true }}

                />

              </Grid>

              <Grid item xs={3}>

                <TextField

                  fullWidth

                  label="Domain Age"

                  value={
                    selectedRecord.domainAge != null && String(selectedRecord.domainAge).trim() !== ''
                      ? `${String(selectedRecord.domainAge).replace(/[^0-9]/g, '')} years`
                      : '-'
                  }

                  InputProps={{ readOnly: true }}

                />

              </Grid>

              <Grid item xs={4}>

                <TextField

                  fullWidth

                  label="Category"

                  value={selectedRecord.category || 'Not set'}

                  InputProps={{ readOnly: true }}

                />

              </Grid>

              <Grid item xs={4}>

                <TextField

                  fullWidth

                  label="Country"

                  value={selectedRecord.country || 'Not set'}

                  InputProps={{ readOnly: true }}

                />

              </Grid>

              <Grid item xs={4}>

                <TextField

                  fullWidth

                  label="Language"

                  value={selectedRecord.language || 'Not set'}

                  InputProps={{ readOnly: true }}

                />

              </Grid>

              <Grid item xs={6}>

                <TextField

                  fullWidth

                  label="TAT"

                  value={selectedRecord.tat || 'Not set'}

                  InputProps={{ readOnly: true }}

                />

              </Grid>

              <Grid item xs={6}>

                <TextField

                  fullWidth

                  label="Status"

                  value={getFinalStatusLabel(selectedRecord.status)}

                  InputProps={{
                    readOnly: true,
                    startAdornment: (
                      <InputAdornment position="start">
                        {getFinalStatusIcon(selectedRecord.status)}
                      </InputAdornment>
                    )
                  }}

                />

              </Grid>

              <Grid item xs={6}>

                <TextField

                  fullWidth

                  label="GB Base Price"

                  value={selectedRecord.gbBasePrice ? `$${selectedRecord.gbBasePrice}` : 'Not set'}

                  InputProps={{ readOnly: true }}

                />

              </Grid>

              <Grid item xs={6}>

                <TextField

                  fullWidth

                  label="LI Base Price"

                  value={selectedRecord.liBasePrice ? `$${selectedRecord.liBasePrice}` : 'Not set'}

                  InputProps={{ readOnly: true }}

                />

              </Grid>

              <Grid item xs={12}>

                <TextField

                  fullWidth

                  label="Negotiation Status"

                  value={selectedRecord.negotiationStatus.replace('_', ' ')}

                  InputProps={{ readOnly: true }}

                />

              </Grid>

              <Grid item xs={12}>

                <TextField

                  fullWidth

                  label="Created At"

                  value={formatDate(selectedRecord.createdAt)}

                  InputProps={{ readOnly: true }}

                />

              </Grid>

            </Grid>

          )}

        </DialogContent>

        <DialogActions>

          <Button onClick={() => setShowViewDialog(false)}>Close</Button>

        </DialogActions>

      </Dialog>



      {/* Edit Dialog */}

      <Dialog open={showEditDialog} onClose={() => setShowEditDialog(false)} maxWidth="md" fullWidth>

        <DialogTitle>Edit Record</DialogTitle>

        <DialogContent sx={{ mt: 2 }}>

          {selectedRecord && (

            <Box>

              <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>

                Site URL: <strong>{selectedRecord.websiteUrl}</strong> (Non-editable)

              </Typography>

              

              <Grid container spacing={2}>

                {/* Contributor: hide publisher alerts, show contact fields only when not matched */}

                {user?.role === 'CONTRIBUTOR' ? (

                  editFormData.publisherMatched ? null : (

                    <>

                      <Grid item xs={12} sm={6}>

                        <TextField

                          fullWidth

                          label="Contact Name"

                          value={editFormData.contactName || ''}

                          onChange={(e) => setEditFormData({...editFormData, contactName: e.target.value})}

                          placeholder="Enter contact person name"

                          helperText="Name of the contact person for this site"

                        />

                      </Grid>

                      <Grid item xs={12} sm={6}>

                        <TextField

                          fullWidth

                          label="Contact Email"

                          type="email"

                          value={editFormData.contactEmail || ''}

                          onChange={(e) => setEditFormData({...editFormData, contactEmail: e.target.value})}

                          placeholder="contact@example.com"

                          helperText="Email of the contact person for this site"

                        />

                      </Grid>

                    </>

                  )

                ) : editFormData.publisherMatched ? (

                  <>

                    <Grid item xs={12}>

                      <Alert severity="success" sx={{ mb: 1 }}>

                        {selectedRecord.publisherId?.startsWith('pending_') ? (

                          <>Publisher will be created in the LM Tool when you push this record.</>

                        ) : (

                          <>Publisher matched from LM Tool: <strong>{editFormData.publisherName}</strong></>

                        )}

                      </Alert>

                    </Grid>

                    {user?.role === 'SUPER_ADMIN' && (

                      <>

                        <Grid item xs={12} sm={6}>

                          <TextField

                            fullWidth

                            label="Publisher Name"

                            value={editFormData.publisherName}

                            onChange={(e) => setEditFormData({...editFormData, publisherName: e.target.value})}

                            helperText="Editable - update publisher name if needed"

                          />

                        </Grid>

                        <Grid item xs={12} sm={6}>

                          <TextField

                            fullWidth

                            label="Publisher Email"

                            type="email"

                            value={editFormData.publisherEmail || ''}

                            onChange={(e) => setEditFormData({...editFormData, publisherEmail: e.target.value})}

                            helperText="Editable - update publisher email if needed"

                          />

                        </Grid>

                      </>

                    )}

                  </>

                ) : (

                  <>

                    {/* Contact fields - only visible when publisher is NOT matched */}

                    <Grid item xs={12} sm={6}>

                      <TextField

                        fullWidth

                        label="Contact Name"

                        value={editFormData.contactName || ''}

                        onChange={(e) => setEditFormData({...editFormData, contactName: e.target.value})}

                        placeholder="Enter contact person name"

                        helperText="Name of the contact person for this site"

                      />

                    </Grid>

                    <Grid item xs={12} sm={6}>

                      <TextField

                        fullWidth

                        label="Contact Email"

                        type="email"

                        value={editFormData.contactEmail || ''}

                        onChange={(e) => setEditFormData({...editFormData, contactEmail: e.target.value})}

                        placeholder="contact@example.com"

                        helperText="Email of the contact person for this site"

                      />

                    </Grid>

                    

                    {/* Mark as Publisher button - when contact info exists */}

                    {user?.role === 'SUPER_ADMIN' && (editFormData.contactName || editFormData.contactEmail) && (

                      <Grid item xs={12}>

                        <Box sx={{ p: 2, bgcolor: 'info.lighter', borderRadius: 1, border: '1px solid', borderColor: 'info.main' }}>

                          <Button

                            variant="contained"

                            color="info"

                            onClick={() => {

                              if (selectedRecord) {

                                setCreatePublisherRecord({

                                  ...selectedRecord,

                                  contactName: editFormData.contactName,

                                  contactEmail: editFormData.contactEmail

                                });

                                setShowCreatePublisherDialog(true);

                              }

                            }}

                            sx={{ mb: 1 }}

                          >

                            Mark as Publisher

                          </Button>

                          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>

                            This will save the contact info as publisher details. When you push this record to the LM Tool:

                          </Typography>

                          <Typography variant="body2" color="text.secondary" component="ul" sx={{ mt: 0.5, pl: 2 }}>

                            <li>If a publisher with this email already exists in LM Tool, it will be linked automatically</li>

                            <li>If not, a new publisher will be created in the LM Tool</li>

                          </Typography>

                        </Box>

                      </Grid>

                    )}

                  </>

                )}

                {/* Metrics: 3 cols/row; Domain Age after TAT */}
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    label="DA"
                    type="number"
                    value={editFormData.da}
                    onChange={(e) => setEditFormData({...editFormData, da: e.target.value})}
                    inputProps={{ min: 0, max: 100, readOnly: user?.role === 'CONTRIBUTOR' }}
                    disabled={user?.role === 'CONTRIBUTOR'}
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    label="DR"
                    type="number"
                    value={editFormData.dr}
                    onChange={(e) => setEditFormData({...editFormData, dr: e.target.value})}
                    inputProps={{ min: 0, max: 100, readOnly: user?.role === 'CONTRIBUTOR' }}
                    disabled={user?.role === 'CONTRIBUTOR'}
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    label="Traffic"
                    type="number"
                    value={editFormData.traffic}
                    onChange={(e) => setEditFormData({...editFormData, traffic: e.target.value})}
                    disabled={user?.role === 'CONTRIBUTOR'}
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    label="SS"
                    type="number"
                    value={editFormData.ss}
                    onChange={(e) => setEditFormData({...editFormData, ss: e.target.value})}
                    inputProps={{ min: 0, max: 100, readOnly: user?.role === 'CONTRIBUTOR' }}
                    disabled={user?.role === 'CONTRIBUTOR'}
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    label="Keywords"
                    type="number"
                    value={editFormData.keywords}
                    onChange={(e) => setEditFormData({...editFormData, keywords: e.target.value})}
                    inputProps={{ min: 0, readOnly: user?.role === 'CONTRIBUTOR' }}
                    disabled={user?.role === 'CONTRIBUTOR'}
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    label="GB Base Price"
                    type="number"
                    value={editFormData.gbBasePrice}
                    onChange={(e) => setEditFormData({...editFormData, gbBasePrice: e.target.value})}
                    InputProps={{ startAdornment: '$' }}
                  />
                </Grid>
                <Grid item xs={4}>
                  <Autocomplete
                    options={LANGUAGES}
                    getOptionLabel={(option) => typeof option === 'string' ? option : option.label}
                    value={toAutocompleteOption(LANGUAGES, editFormData.language, 'language')}
                    onChange={(_, newValue) => setEditFormData({...editFormData, language: newValue?.value || ''})}
                    isOptionEqualToValue={(option, value) => option.value === value?.value}
                    disabled={user?.role === 'CONTRIBUTOR'}
                    readOnly={user?.role === 'CONTRIBUTOR'}
                    renderInput={(params) => (
                      <TextField {...params} label="Language" />
                    )}
                  />
                </Grid>
                <Grid item xs={4}>
                  <Autocomplete
                    options={[...categories].sort((a, b) => a.label.localeCompare(b.label))}
                    getOptionLabel={(option) => typeof option === 'string' ? option : option.label}
                    value={toAutocompleteOption(categories, editFormData.category, 'category')}
                    onChange={(_, newValue) => setEditFormData({...editFormData, category: newValue?.value || ''})}
                    isOptionEqualToValue={(option, value) => option.value === value?.value}
                    disabled={user?.role === 'CONTRIBUTOR'}
                    readOnly={user?.role === 'CONTRIBUTOR'}
                    renderInput={(params) => (
                      <TextField {...params} label="Category" />
                    )}
                  />
                </Grid>
                <Grid item xs={4}>
                  <Autocomplete
                    options={COUNTRIES}
                    getOptionLabel={(option) => typeof option === 'string' ? option : option.label}
                    value={toAutocompleteOption(COUNTRIES, editFormData.country, 'country')}
                    onChange={(_, newValue) => setEditFormData({...editFormData, country: newValue?.value || ''})}
                    isOptionEqualToValue={(option, value) => option.value === value?.value}
                    disabled={user?.role === 'CONTRIBUTOR'}
                    readOnly={user?.role === 'CONTRIBUTOR'}
                    renderInput={(params) => (
                      <TextField {...params} label="Country" />
                    )}
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    label="LI Base Price"
                    type="number"
                    value={editFormData.liBasePrice}
                    onChange={(e) => setEditFormData({...editFormData, liBasePrice: e.target.value})}
                    InputProps={{ startAdornment: '$' }}
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    label="TAT"
                    value={editFormData.tat}
                    onChange={(e) => setEditFormData({...editFormData, tat: e.target.value})}
                    placeholder="e.g., 1-2 days"
                    disabled={user?.role === 'CONTRIBUTOR'}
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    label="Domain Age"
                    type="number"
                    value={editFormData.domainAge}
                    onChange={(e) => setEditFormData({...editFormData, domainAge: e.target.value})}
                    placeholder="e.g., 6"
                    inputProps={{ min: 0, readOnly: user?.role === 'CONTRIBUTOR' }}
                    disabled={user?.role === 'CONTRIBUTOR'}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Image Link"
                    value={editFormData.imageLink}
                    onChange={(e) => setEditFormData({...editFormData, imageLink: e.target.value})}
                    placeholder="https://prnt.sc/..."
                    helperText="Screenshot / image URL for this Email Sent record"
                    disabled={user?.role === 'CONTRIBUTOR'}
                    InputProps={{
                      endAdornment: editFormData.imageLink?.trim() ? (
                        <InputAdornment position="end">
                          <Tooltip title="Open image link">
                            <IconButton
                              size="small"
                              edge="end"
                              component="a"
                              href={
                                editFormData.imageLink.trim().startsWith('http')
                                  ? editFormData.imageLink.trim()
                                  : `https://${editFormData.imageLink.trim()}`
                              }
                              target="_blank"
                              rel="noopener noreferrer"
                              aria-label="Open image link"
                              onClick={(e) => e.stopPropagation()}
                            >
                              <LinkIcon fontSize="small" color="primary" />
                            </IconButton>
                          </Tooltip>
                        </InputAdornment>
                      ) : undefined
                    }}
                  />
                </Grid>
                <Grid item xs={4}>
                  <FormControl fullWidth disabled={user?.role === 'CONTRIBUTOR'}>
                    <InputLabel>Status</InputLabel>
                    <Select
                      value={
                        editFormData.status === 'ACTIVE' || editFormData.status === 'INACTIVE'
                          ? 'EMAIL_SENT'
                          : editFormData.status
                      }
                      label="Status"
                      onChange={(e) => setEditFormData({...editFormData, status: e.target.value})}
                      readOnly={user?.role === 'CONTRIBUTOR'}
                      renderValue={(selected) => (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          {getFinalStatusIcon(String(selected))}
                          {getFinalStatusLabel(String(selected))}
                        </Box>
                      )}
                    >
                      <MenuItem value="EMAIL_SENT">
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <MarkEmailReadIcon fontSize="small" sx={{ color: '#2e7d32' }} /> Email Sent
                        </Box>
                      </MenuItem>
                      <MenuItem value="RESPONSE_RECEIVED">
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <MarkunreadMailboxIcon fontSize="small" sx={{ color: '#1565c0' }} /> Response Received
                        </Box>
                      </MenuItem>
                      <MenuItem value="FINAL_COST">
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <AttachMoneyIcon fontSize="small" sx={{ color: '#6a1b9a' }} /> Final Cost
                        </Box>
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={4}>
                  <FormControl fullWidth>
                    <InputLabel>Negotiation Status</InputLabel>
                    <Select
                      value={editFormData.negotiationStatus}
                      label="Negotiation Status"
                      onChange={(e) => setEditFormData({...editFormData, negotiationStatus: e.target.value})}
                    >
                      <MenuItem value="IN_PROGRESS">In Progress</MenuItem>
                      <MenuItem value="DONE">Done</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>



              </Grid>

            </Box>

          )}

        </DialogContent>

        <DialogActions>

          <Button onClick={() => setShowEditDialog(false)} disabled={saving}>

            Cancel

          </Button>

          <Button 

            onClick={handleSaveEdit} 

            variant="contained" 

            disabled={saving}

            startIcon={saving ? <CircularProgress size={16} /> : null}

          >

            {saving ? 'Saving...' : 'Save Changes'}

          </Button>

        </DialogActions>

      </Dialog>



      {/* Mark as Publisher Dialog */}

      <Dialog open={showCreatePublisherDialog} onClose={() => setShowCreatePublisherDialog(false)} maxWidth="sm" fullWidth>

        <DialogTitle>Mark as Publisher</DialogTitle>

        <DialogContent sx={{ mt: 2 }}>

          {createPublisherRecord && (

            <Box>

              <Alert severity="info" sx={{ mb: 2 }}>

                This will save the contact info as publisher details for this site.

              </Alert>

              <Grid container spacing={2}>

                <Grid item xs={12}>

                  <TextField

                    fullWidth

                    label="Site URL"

                    value={createPublisherRecord.websiteUrl}

                    InputProps={{ readOnly: true }}

                  />

                </Grid>

                <Grid item xs={12} sm={6}>

                  <TextField

                    fullWidth

                    label="Publisher Name"

                    value={createPublisherRecord.contactName || ''}

                    InputProps={{ readOnly: true }}

                  />

                </Grid>

                <Grid item xs={12} sm={6}>

                  <TextField

                    fullWidth

                    label="Publisher Email"

                    value={createPublisherRecord.contactEmail || ''}

                    InputProps={{ readOnly: true }}

                  />

                </Grid>

              </Grid>

              <Alert severity="success" sx={{ mt: 2 }}>

                <strong>When you push this record to the LM Tool:</strong>

                <ul style={{ margin: '8px 0 0 0', paddingLeft: '20px' }}>

                  <li>If a publisher with this email already exists, it will be linked automatically</li>

                  <li>If not, a new publisher will be created in the LM Tool</li>

                  <li>Other sites with the same email will also use this publisher</li>

                </ul>

              </Alert>

            </Box>

          )}

        </DialogContent>

        <DialogActions>

          <Button onClick={() => setShowCreatePublisherDialog(false)} disabled={creatingPublisher}>

            Cancel

          </Button>

          <Button 

            onClick={handleCreatePublisher} 

            variant="contained" 

            color="info"

            disabled={creatingPublisher}

            startIcon={creatingPublisher ? <CircularProgress size={16} /> : null}

          >

            {creatingPublisher ? 'Marking...' : 'Mark as Publisher'}

          </Button>

        </DialogActions>

      </Dialog>



      {/* Export by Publisher Dialog */}

      <Dialog open={showExportDialog} onClose={() => setShowExportDialog(false)} maxWidth="sm" fullWidth>

        <DialogTitle>Export Data by Publisher</DialogTitle>

        <DialogContent sx={{ mt: 2 }}>

          <Box>

            <Alert severity="info" sx={{ mb: 2 }}>

              Export all records for a specific publisher as CSV file.

            </Alert>

            

            <FormControl fullWidth sx={{ mb: 2 }}>

              <InputLabel>Select Publisher</InputLabel>

              <Select

                value={selectedExportPublisher}

                label="Select Publisher"

                onChange={(e) => setSelectedExportPublisher(e.target.value)}

              >

                {exportPublishers.map((publisher) => (

                  <MenuItem key={publisher.email} value={publisher.email}>

                    <Box>

                      <Typography variant="body2">

                        {publisher.name} ({publisher.recordCount} records)

                      </Typography>

                      <Typography variant="caption" color="text.secondary">

                        {publisher.email} {publisher.isMatched ? '• Matched Publisher' : '• Contact'}

                      </Typography>

                    </Box>

                  </MenuItem>

                ))}

              </Select>

            </FormControl>

            

            {selectedExportPublisher && (

              <Alert severity="success" sx={{ mt: 2 }}>

                <strong>Export will include:</strong>

                <ul style={{ margin: '8px 0 0 0', paddingLeft: '20px' }}>

                  <li>All website records for this publisher</li>

                  <li>Complete site details (DA, DR, Traffic, SS, etc.)</li>

                  <li>Pricing information and status</li>

                  <li>Push status and timestamps</li>

                </ul>

              </Alert>

            )}

          </Box>

        </DialogContent>

        <DialogActions>

          <Button onClick={() => {

            setShowExportDialog(false);

            setSelectedExportPublisher('');

          }} disabled={exporting}>

            Cancel

          </Button>

          <Button 

            onClick={handleExportByPublisher} 

            variant="contained" 

            color="info"

            disabled={exporting || !selectedExportPublisher}

            startIcon={exporting ? <CircularProgress size={16} /> : <span>📊</span>}

          >

            {exporting ? 'Exporting...' : 'Export CSV'}

          </Button>

        </DialogActions>

      </Dialog>



      {/* Toast Notification Snackbar */}

      <Snackbar

        open={snackbar.open}

        autoHideDuration={4000}

        onClose={() => setSnackbar({ ...snackbar, open: false })}

        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}

      >

        <Alert 

          onClose={() => setSnackbar({ ...snackbar, open: false })} 

          severity={snackbar.severity}

          sx={{ 

            width: '100%',

            color: '#ffffff',

            '& .MuiAlert-icon': {

              color: '#ffffff'

            }

          }}

          variant="filled"

        >

          {snackbar.message}

        </Alert>

      </Snackbar>

    </Box>

  );

};



export default DataFinal;

